import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row gap-2"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "text-gray-800 text-md leading-6 text-left" }
const _hoisted_6 = {
  key: 1,
  class: "text-gray-800 text-md leading-6 text-left"
}
const _hoisted_7 = { class: "text-gray-500 text-md leading-6 text-left" }
const _hoisted_8 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_9 = { class: "flex flex-row gap-1" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "text-gray-800 text-md font-semibold leading-6 text-left" }
const _hoisted_12 = { class: "text-gray-500 text-md leading-6 text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-lg font-semibold text-gray-900 text-left mb-4" }, " Your Current Payment Method ", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.source === 'credit_card')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", { innerHTML: _ctx.CARD_ICON }, null, 8, _hoisted_4),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.cardNumber), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.source === 'credit_card')
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
            _cache[0] || (_cache[0] = _createTextVNode(" Expiration Date: ")),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.cardExpiry), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.source === 'invoice')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", { innerHTML: _ctx.DOCUMENT_DOLLAR_ICON }, null, 8, _hoisted_10),
              _createElementVNode("span", _hoisted_11, [
                _cache[1] || (_cache[1] = _createTextVNode(" Invoice will be mailed to: ")),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.invoiceRecipientEmail), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}